module.exports = __webpack_public_path__ + "static/media/noun-gym-1396008-142350.3fe97b10.svg";